// Map API keys to Human Readable Labels
export const keyMappings = {
  med_complaint: "Complaint",
  med_symptoms: "Symptoms",
  med_suggestion: "Treatment",
  med_remarks: "Remarks",
  med_height: "Height (cm)",
  med_weight: "Weight (kg)",
  med_body_temp: "Temp (°F)",
  med_bp_sys: "BP (Sys)",
  med_bp_dia: "BP (Dia)",
  med_heart_rate: "Heart Rate",
  med_respiratory_rate: "Resp. Rate",
  med_called_parents: "Parents Called",
  med_called_ambulance: "Ambulance Called",
};
